import React from 'react';
import InvitationPreviewV2 from './InvitationPreview/InvitationPreviewV2';
import { InvitationDesign } from '../_types/invitation-design-v2';
import { Event } from '../_graphql/generated/operations';
import { PageSize } from './PDFDownloadModal';

interface InvitationPDFWrapperProps {
  design: InvitationDesign;
  event: Event;
  pageSize: PageSize;
  removeBackground?: boolean;
  removeBorder?: boolean;
}

const InvitationPDFWrapper: React.FC<InvitationPDFWrapperProps> = ({
  design,
  event,
  pageSize,
  removeBackground = false,
  removeBorder = false,
}) => {
  // Calculate dimensions based on page size
  const baseWidth = 528; // Keep readable width
  const pageAspectRatio = pageSize.width / pageSize.height;
  const targetHeight = Math.round(baseWidth / pageAspectRatio);
  
  // Create modified design if needed
  const modifiedDesign = React.useMemo(() => {
    if (!removeBackground && !removeBorder) return design;
    
    const newDesign = { ...design };
    
    if (removeBackground) {
      newDesign.template = {
        ...newDesign.template,
        background: {
          type: 'solid',
          value: '#ffffff'
        }
      };
    }
    
    if (removeBorder) {
      newDesign.template = {
        ...newDesign.template,
        border: {
          style: 'solid',
          width: 0,
          color: 'transparent'
        }
      };
    }
    
    return newDesign;
  }, [design, removeBackground, removeBorder]);
  
  return (
    <div id="pdf-invitation-wrapper" style={{ width: baseWidth, height: targetHeight, backgroundColor: '#ffffff' }}>
      <InvitationPreviewV2
        design={modifiedDesign}
        event={event}
        isEditing={false}
        customDimensions={{
          width: baseWidth,
          height: targetHeight
        }}
      />
    </div>
  );
};

export default InvitationPDFWrapper;